const UserHome = () => import('@/views/user/index.vue')
const basicInfo = () => import('@/views/user/pages/basicInfo.vue')
const setting = () => import('@/views/user/pages/setting.vue')

export default {
  path: '/',
  component: UserHome,
  children: [{
    name: 'user',
    path: 'user',
    component: basicInfo
  }, {
    name: 'setting',
    path: 'setting',
    component: setting
  }]
}



// WEBPACK FOOTER //
// ./src/router/user/index.js